import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Item from './Item'

export default {
  name: 'BotDestinationModal',
  components: {
    Loading,
    Item
  },
  data () {
    return {
      loading: false,
      processing: false,
      inpNotifyTo: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.botDestinationModal.active,

      // form
      botUuid: state => state.botDestinationModal.targetId,
      values: state => state.botDestinationModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // list
    itemList () {
      let list = []
      for (let i = 0, l = 5; i < l; i++) {
        list.push({
          index: i,
          value: this.values[i] ? this.values[i] : ''
        })
      }
      return list
    },

    // disabled
    disablePostButton () {
      if (this.filterMode === 0) return false
        return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'botDestinationModal/hide'
    }),

    init () {
      let org = ['', '', '', '', '']
      this.inpNotifyTo = $.extend(true, org, this.values)
      console.log('BotDestinationModal.init : ', this.inpNotifyTo)
    },

    setValue (props) {
      this.$set(this.inpNotifyTo, props.index, props.value)
    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容で通知先メールアドレスを登録しますか？',
        acceptLabel: '登録'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        botUuid: this.botUuid,
        request: {
          notifyTo: this.inpNotifyTo.filter(item => item !== '')
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['bot'],
        ['v1BotNotify'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '通知先メールアドレス設定',
              body: '「通知先メールアドレス」を変更しました。'
            })

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}